import { useContext } from 'react';
import { SessionContext, type SessionState } from './SessionProvider';

/**
 * The current session state. Always branch on `status` — treating a `null`
 * session as "signed out" swallows the `loading` case.
 */
export function useSession(): SessionState {
  const state = useContext(SessionContext);
  if (!state) throw new Error('useSession must be used inside <SessionProvider>');
  return state;
}

/** The signed-in user, or `null` while loading and when signed out. */
export function useUser() {
  return useSession().session?.user ?? null;
}
